import { ReadonlyURLSearchParams } from 'next/navigation';

const serializePath = (
  pathname: string,
  searchParams: ReadonlyURLSearchParams | URLSearchParams
): string => {
  const searchParamsStr = searchParams.toString();
  const searchParamsSuffix = searchParamsStr.length === 0 ? '' : `?${searchParamsStr}`;
  return `${pathname}${searchParamsSuffix}`;
};

export default serializePath;
